import { useState } from "react";

import Select from 'react-select';
import Creatable from 'react-select/creatable';
import ButtonLoader from '../ButtonLoader';

import designAndEngineeringProjectStatuses from '../../data/designAndEngineeringProjectStatuses.json';
import DatePicker from "react-date-picker";

import usePartnerCompanies from '../../hooks/usePartnerCompanies';

const DesignAndEngineeringProjectForm = ({ project, clients, isLoading, onSubmit }) => {
  const [name, setName] = useState(project?.name || '');
  const [poNumber, setPoNumber] = useState(project?.poNumber || '');

  const defaultClient = project ? { value: project.client, label: project.client } : null;
  const [client, setClient] = useState(defaultClient);

  const [startDate, setStartDate] = useState(project?.startDate ? new Date(project?.startDate) : new Date());
  const [endDate, setEndDate] = useState(project?.endDate ? new Date(project?.endDate) : new Date());

  const defaultEngineeringCompany = project?.engineeringCompany ? { value: project.engineeringCompany._id, label: project.engineeringCompany.name } : null;
  const [engineeringCompany, setEngineeringCompany] = useState(defaultEngineeringCompany);

  const defaultDesignCompany = project?.designCompany ? { value: project.designCompany._id, label: project.designCompany.name } : null;
  const [designCompany, setDesignCompany] = useState(defaultDesignCompany);

  const defaultStatus = project
    ? designAndEngineeringProjectStatuses.find(status => status.value === project.status)
    : designAndEngineeringProjectStatuses[0];

  const [status, setStatus] = useState(defaultStatus);

  const { data: partnerCompaniesData, isLoading: isLoadingPartnerCompanies } = usePartnerCompanies({
    page: 1,
    perPage: 1000
  });

  const partnerCompanies = partnerCompaniesData?.partnerCompanies;

  const handleSubmit = e => {
    e.preventDefault();

    onSubmit({
      name,
      client: client.value,
      startDate,
      endDate,
      poNumber,
      status: status.value,
      engineeringCompany: engineeringCompany.value,
      designCompany: designCompany.value,
    });
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col gap-4 w-full"
    >
      <label className="flex flex-col gap-1 w-full">
        Name

        <input
          type="text"
          value={name}
          onChange={e => setName(e.target.value)}
        />
      </label>

      <label className="flex flex-col gap-1 w-full">
        Client

        <Creatable
          value={client}
          options={clients?.map(c => ({ value: c, label: c }))}
          onChange={setClient}
        />
      </label>

      <div className="flex gap-4">
        <label className="flex flex-col gap-1 w-full">
          Status

          <Select
            value={status}
            options={designAndEngineeringProjectStatuses}
            onChange={setStatus}
          />
        </label>

        <label className="flex flex-col gap-1 w-full">
          PO #

          <input
            type="text"
            value={poNumber}
            onChange={e => setPoNumber(e.target.value)}
          />
        </label>
      </div>

      <div className="flex gap-4">
        <label className="flex flex-col gap-1 w-full">
          Start date

          <DatePicker
            value={startDate}
            onChange={setStartDate}
            required={true}
            clearIcon={null}
            format="d/M/yyyy"
            className="h-[46px]"
            maxDetail="month"
            minDetail="year"
          />
        </label>

        <label className="flex flex-col gap-1 w-full">
          End date

          <DatePicker
            value={endDate}
            onChange={setEndDate}
            required={true}
            clearIcon={null}
            format="d/M/yyyy"
            className="h-[46px]"
            maxDetail="month"
            minDetail="year"
          />
        </label>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <label className="flex flex-col gap-1 w-full">
          Engineers

          <Select
            value={engineeringCompany}
            options={partnerCompanies?.map(c => ({ value: c._id, label: c.name }))}
            onChange={setEngineeringCompany}
            isLoading={isLoadingPartnerCompanies}
            isDisabled={isLoadingPartnerCompanies}
          />
        </label>

        <label className="flex flex-col gap-1 w-full">
          Designers

          <Select
            value={designCompany}
            options={partnerCompanies?.map(c => ({ value: c._id, label: c.name }))}
            onChange={setDesignCompany}
            isLoading={isLoadingPartnerCompanies}
            isDisabled={isLoadingPartnerCompanies}
          />
        </label>
      </div>

      <button
        type="submit"
        className="ase-button-primary h-[48px] flex items-center justify-center"
      >
        {isLoading ? <ButtonLoader /> : 'Submit'}
      </button>
    </form>
  )
}

export default DesignAndEngineeringProjectForm;
